import { gql } from '@apollo/client';

export const ACTIVATIONS_QUERY = gql`
  query ActivationsQuery {
    activations {
      id
      audience {
        id
        name
        recordsIncluded
      }
      # ATAD-132: denormalized fallbacks. audience and destinationPartner
      # are nullable — audiences are hard deleted, and activations from the
      # retired checkout flow never stored a destination ref — but these two
      # strings are copied onto the activation itself and always survive.
      audienceName
      destinationPartnerName
      destinationPartner {
        id
        name
        slug
        displayName
        filenameSuffix
      }
      percentSelected
      recordsIncluded
      processingStatus
      recordsSuccessful
      recordsFailed
      startedAt
      finishedAt
    }
  }
`;

export const ACTIVATION_QUERY = gql`
  query ActivationQuery($activationId: ID!) {
    activation(activationId: $activationId) {
      id
      audience {
        id
        name
        recordsIncluded
      }
      # ATAD-132: denormalized fallbacks. audience and destinationPartner
      # are nullable — audiences are hard deleted, and activations from the
      # retired checkout flow never stored a destination ref — but these two
      # strings are copied onto the activation itself and always survive.
      audienceName
      destinationPartnerName
      destinationPartner {
        id
        name
        slug
        displayName
        filenameSuffix
      }
      percentSelected
      recordsIncluded
      processingStatus
      recordsSuccessful
      recordsFailed
      processingId
      startedAt
      finishedAt
    }
  }
`;
